import { AxiosResponse } from "axios";
import {
  RemoteExecutionServiceImpl,
  RemoteGETCallInputObject,
  ServerResponse,
  RemotePOSTCallInputObject,
} from "../../remoteExecution/RemoteExecutionServiceImpl";
import { getAccessToken } from "../../common/CommonUtilsMethods";
import axios from 'axios';
import { AgencySalesLeadDTO, CreateAgencySalesLeadNoteDTO, UpdateSalesLeadStatusDTO, CreateSalesLeadRequestDTO, UpdateSalesLeadNoteDTO, CreateTargetBusinessLeadOrgEmployeeContactRequestDTO, CreateTargetBusinessLeadOrgEmployeeContactResponseDTO, MarkContactElementValueReqDTO, MarkContactElementValueResDTO, UpdateContactDetailReqDTO, UpdateContactDetailResponseDTO, SendEmailRequestDTO, SendEmailResponseDTO, AgencyTeamMembersResponseDTO, AssignTeamMemberReqDTO, SellerClientTagDTO, AssignedTagsToLeadDTO, AssignTagToLeadDTO, AssignTagToLeadsDTO, BatchTagAssignmentResult, TagDTO, WorkyLeadTagDTO, CurrentLeadsAPIRespObj, FIRST_CALL_EXCLUSIVE_START_KEY, GroupedLeadStatusChangeEventsDTO, BulkUpdateSalesLeadStatusDTO, BulkUpdateSalesLeadStatusResponseDTO, EmailCalendarTaskDTO, EmailCalendarTaskRespDTO, ViewEventsRespDTO, CreateSalesLeadRequestV2DTO } from "../worky-leads-interfaces/WorkyLeadsInterfaces";

const backendApiBasePathLocal = process.env.REACT_APP_BACK_END_SERVER_BASE_PATH_LOCAL;
const remoteCallObject = RemoteExecutionServiceImpl();

const GetAgencySalesLeadAPICall = async (): Promise<AgencySalesLeadDTO[] | null> => {
  const getCallInput: RemoteGETCallInputObject = {
    // apiUrl: `${backendApiBasePathLocal}agency/sales/current-leads/`,
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/current-leads`,
    headers: {},
    queryParams: null,
  };

  const orgBillsResponse: AxiosResponse<ServerResponse<AgencySalesLeadDTO[], Error>> | undefined = await remoteCallObject.remoteGETCallV2<
    ServerResponse<AgencySalesLeadDTO[], Error>
  >(getCallInput);

  if (orgBillsResponse && orgBillsResponse.data && orgBillsResponse.data.data) {
    return orgBillsResponse.data.data;
  } else {
    return null;
  }
};
const GetAgencySalesLeadDetailsAPICall = async (leadId: string): Promise<AgencySalesLeadDTO | null> => {
    const getCallInput: RemoteGETCallInputObject = {
        apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/current-leads/details`,
        headers: {},
        queryParams: { leadId },
    };

    const response: AxiosResponse<ServerResponse<AgencySalesLeadDTO, Error>> | undefined = await remoteCallObject.remoteGETCallV2<
        ServerResponse<AgencySalesLeadDTO, Error>
    >(getCallInput);

    if (response && response.data && response.data.data) {
        return response.data.data;
    } else {
        return null;
    }
};


const GetAgencyTeamMembersAPICall = async (): Promise<AgencyTeamMembersResponseDTO | null> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/team-members`,
    headers: {},
    queryParams: null,
  };

  const response: AxiosResponse<ServerResponse<AgencyTeamMembersResponseDTO, Error>> | undefined = await remoteCallObject.remoteGETCallV2<
    ServerResponse<AgencyTeamMembersResponseDTO, Error>
  >(getCallInput);

  if (response?.data?.data) {
    return response.data.data;
  } else {
    return null;
  }
};

const AssignLeadsToTeamMemberAPICall = async (request: AssignTeamMemberReqDTO): Promise<readonly string[] | null> => {
  const postCallInput: RemotePOSTCallInputObject<AssignTeamMemberReqDTO> = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/assign-leads`,
    headers: {},
    object: request,
  };

  const response: AxiosResponse<ServerResponse<readonly string[], Error>> =
    await remoteCallObject.remotePOSTCallV2<ServerResponse<readonly string[], Error>, AssignTeamMemberReqDTO>(postCallInput);

  if (response && response.data && response.data.data) {
    return response.data.data;
  } else {
    return null;
  }
};




const CreateAgencySalesLeadNoteAPICall = async (downloadPDfReq: CreateAgencySalesLeadNoteDTO): Promise<AgencySalesLeadDTO | null> => {
    const postCallInput: RemotePOSTCallInputObject<CreateAgencySalesLeadNoteDTO> = {
      apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/create-note`,
      headers: { },
      object:downloadPDfReq,    
    };
  
    const createAgencySalesNoteResp: AxiosResponse<ServerResponse<AgencySalesLeadDTO, Error>> = 
    await remoteCallObject.remotePOSTCallV2<ServerResponse<AgencySalesLeadDTO, Error>,CreateAgencySalesLeadNoteDTO>(postCallInput);
  
    if (createAgencySalesNoteResp && createAgencySalesNoteResp.data && createAgencySalesNoteResp.data.data) {
      return createAgencySalesNoteResp.data.data;
    } else {
      return null;
    }
  
  };



const AddTargetBusinessLeadOrgEmployeeContactAPICall = async (downloadPDfReq: CreateTargetBusinessLeadOrgEmployeeContactRequestDTO): Promise<CreateTargetBusinessLeadOrgEmployeeContactResponseDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<CreateTargetBusinessLeadOrgEmployeeContactRequestDTO> = {
    apiUrl: `${backendApiBasePathLocal}v2/worky-leads/contact-details/employee-contacts`,
    headers: { },
    object:downloadPDfReq,    
  };

  const createAgencySalesNoteResp: AxiosResponse<ServerResponse<CreateTargetBusinessLeadOrgEmployeeContactResponseDTO, Error>> = 
  await remoteCallObject.remotePOSTCallV2<ServerResponse<CreateTargetBusinessLeadOrgEmployeeContactResponseDTO, Error>,CreateTargetBusinessLeadOrgEmployeeContactRequestDTO>(postCallInput);

  if (createAgencySalesNoteResp && createAgencySalesNoteResp.data && createAgencySalesNoteResp.data.data) {
    return createAgencySalesNoteResp.data.data;
  } else {
    return null;
  }

};




const UpdateSalesLeadNoteDTOAPICall = async (downloadPDfReq: UpdateSalesLeadNoteDTO): Promise<AgencySalesLeadDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<CreateAgencySalesLeadNoteDTO> = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/update-note`,
    headers: { },
    object:downloadPDfReq,    
  };

  const createAgencySalesNoteResp: AxiosResponse<ServerResponse<AgencySalesLeadDTO, Error>> = 
  await remoteCallObject.remotePOSTCallV2<ServerResponse<AgencySalesLeadDTO, Error>,CreateAgencySalesLeadNoteDTO>(postCallInput);

  if (createAgencySalesNoteResp && createAgencySalesNoteResp.data && createAgencySalesNoteResp.data.data) {
    return createAgencySalesNoteResp.data.data;
  } else {
    return null;
  }

};




const UpdateSalesLeadStatusAPICall = async (updateStatusReq: BulkUpdateSalesLeadStatusDTO): Promise<BulkUpdateSalesLeadStatusResponseDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<BulkUpdateSalesLeadStatusDTO> = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/update-status`,
    headers: {},
    object: updateStatusReq,
  };

  const updateStatusResp: AxiosResponse<ServerResponse<BulkUpdateSalesLeadStatusResponseDTO, Error>> = 
    await remoteCallObject.remotePOSTCallV2<ServerResponse<BulkUpdateSalesLeadStatusResponseDTO, Error>, BulkUpdateSalesLeadStatusDTO>(postCallInput);

  if (updateStatusResp && updateStatusResp.data && updateStatusResp.data.data) {
    return updateStatusResp.data.data;
  } else {
    return null;
  }
};


const CreateNewLeadAPICall = async (createSalesLeadRequestDTO: readonly CreateSalesLeadRequestV2DTO[]): Promise<AgencySalesLeadDTO[] | null> => {
  const postCallInput: RemotePOSTCallInputObject<readonly CreateSalesLeadRequestV2DTO[]> = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/create-new-lead`,
    headers: {},
    object: createSalesLeadRequestDTO,
  };

  const createSalesLeadResp: AxiosResponse<ServerResponse<AgencySalesLeadDTO[], Error>> = 
    await remoteCallObject.remotePOSTCallV2<ServerResponse<AgencySalesLeadDTO[], Error>, readonly CreateSalesLeadRequestV2DTO[]>(postCallInput);

  if (createSalesLeadResp && createSalesLeadResp.data && createSalesLeadResp.data.data) {
    return createSalesLeadResp.data.data;
  } else {
    return null;
  }
};



const CreateSalesLeadContactPhoneNumberFeedbackAPICall = async (inputRequest: MarkContactElementValueReqDTO): Promise<MarkContactElementValueResDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<MarkContactElementValueReqDTO> = {
    apiUrl: `${backendApiBasePathLocal}v1/worky-leads/seller-client/feedback/mark-contact-phonenumber`,
    headers: {},
    object: inputRequest,
  };

  const createSalesLeadResp: AxiosResponse<ServerResponse<MarkContactElementValueResDTO, Error>> = 
    await remoteCallObject.remotePOSTCallV2<ServerResponse<MarkContactElementValueResDTO, Error>, MarkContactElementValueReqDTO>(postCallInput);

  if (createSalesLeadResp && createSalesLeadResp.data && createSalesLeadResp.data.data) {
    return createSalesLeadResp.data.data;
  } else {
    return null;
  }
};




const CreateSalesLeadContactEmailFeedbackAPICall = async (inputRequest: MarkContactElementValueReqDTO): Promise<MarkContactElementValueResDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<MarkContactElementValueReqDTO> = {
    apiUrl: `${backendApiBasePathLocal}v1/worky-leads/seller-client/feedback/mark-contact-email`,
    headers: {},
    object: inputRequest,
  };

  const createSalesLeadResp: AxiosResponse<ServerResponse<MarkContactElementValueResDTO, Error>> = 
    await remoteCallObject.remotePOSTCallV2<ServerResponse<MarkContactElementValueResDTO, Error>, MarkContactElementValueReqDTO>(postCallInput);

  if (createSalesLeadResp && createSalesLeadResp.data && createSalesLeadResp.data.data) {
    return createSalesLeadResp.data.data;
  } else {
    return null;
  }
};

const UpdateContactDetailEmailsAPICall = async (inputRequest: UpdateContactDetailReqDTO[]): Promise<UpdateContactDetailResponseDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<UpdateContactDetailReqDTO[]> = {
    apiUrl: `${backendApiBasePathLocal}v2/worky-leads/contact-details/emails`,
    headers: {},
    object: inputRequest,
  };

  const updateContactDetailResp: AxiosResponse<ServerResponse<UpdateContactDetailResponseDTO, Error>> = 
    await remoteCallObject.remotePOSTCallV2<ServerResponse<UpdateContactDetailResponseDTO, Error>, UpdateContactDetailReqDTO[]>(postCallInput);

  if (updateContactDetailResp && updateContactDetailResp.data && updateContactDetailResp.data.data) {
    return updateContactDetailResp.data.data;
  } else {
    return null;
  }
};

const UpdateContactDetailPhonesAPICall = async (inputRequest: UpdateContactDetailReqDTO[]): Promise<UpdateContactDetailResponseDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<UpdateContactDetailReqDTO[]> = {
    apiUrl: `${backendApiBasePathLocal}v2/worky-leads/contact-details/phones`,
    headers: {},
    object: inputRequest,
  };

  const updateContactDetailResp: AxiosResponse<ServerResponse<UpdateContactDetailResponseDTO, Error>> = 
    await remoteCallObject.remotePOSTCallV2<ServerResponse<UpdateContactDetailResponseDTO, Error>, UpdateContactDetailReqDTO[]>(postCallInput);

  if (updateContactDetailResp && updateContactDetailResp.data && updateContactDetailResp.data.data) {
    return updateContactDetailResp.data.data;
  } else {
    return null;
  }
};

const SendSellerClientEmailAPICall = async (sendEmailRequest: SendEmailRequestDTO): Promise<SendEmailResponseDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<SendEmailRequestDTO> = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/email-seller-client`,
    headers: {},
    object: sendEmailRequest,
  };

  const sendEmailResp: AxiosResponse<ServerResponse<SendEmailResponseDTO, Error>> = 
    await remoteCallObject.remotePOSTCallV2<ServerResponse<SendEmailResponseDTO, Error>, SendEmailRequestDTO>(postCallInput);

  if (sendEmailResp && sendEmailResp.data && sendEmailResp.data.data) {
    return sendEmailResp.data.data;
  } else {
    return null;
  }
};


const GetCurrentLeadsV2APICall = async (
  exclusiveStartKey: string,
  statusNames?: readonly string[],
  maxRecordsReturned?: number,
  workyLeadsSortCondition?: string
): Promise<CurrentLeadsAPIRespObj | null> => {
  const queryParams: Record<string, string> = {};

  /**
   * protect against undefined exclusiveStartKey which can cause infinite loop
   */
  if(!exclusiveStartKey){
    console.log('GetCurrentLeadsV2APICall: exclusiveStartKey is undefined');
    return null;
  }else if(exclusiveStartKey === FIRST_CALL_EXCLUSIVE_START_KEY){
    console.log('GetCurrentLeadsV2APICall: exclusiveStartKey is FIRST_CALL_EXCLUSIVE_START_KEY');
    exclusiveStartKey = undefined;
  }

  if (statusNames && statusNames.length > 0) {
    queryParams.statusNames = statusNames.join(',');
  }

  if (exclusiveStartKey) {
    queryParams.exclusiveStartKey = exclusiveStartKey;
  }

  if (maxRecordsReturned !== undefined) {
    queryParams.maxRecordsReturned = maxRecordsReturned.toString();
  }

  if (workyLeadsSortCondition) {
    queryParams.workyLeadsSortCondition = workyLeadsSortCondition;
  }

  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: `${backendApiBasePathLocal}v2/seller-client/sales/current-leads`,
    headers: {},
    queryParams: Object.keys(queryParams).length > 0 ? queryParams : undefined,
  };

  const response: AxiosResponse<ServerResponse<CurrentLeadsAPIRespObj, Error>> | undefined = await remoteCallObject.remoteGETCallV2<
    ServerResponse<CurrentLeadsAPIRespObj, Error>
  >(getCallInput);

  if (response?.data?.data) {
    return response.data.data;
  } else {
    return null;
  }
};

const GetSellerClientTagsAPICall = async (): Promise<SellerClientTagDTO[] | null> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/find-seller-client-tags`,
    headers: {},
    queryParams: null,
  };

  const response: AxiosResponse<ServerResponse<SellerClientTagDTO[], Error>> | undefined = await remoteCallObject.remoteGETCallV2<
    ServerResponse<SellerClientTagDTO[], Error>
  >(getCallInput);

  if (response?.data?.data) {
    return response.data.data;
  } else {
    return null;
  }
};

const GetAssignedTagsForLeadAPICall = async (leadId: string): Promise<AssignedTagsToLeadDTO[] | null> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/find-assigned-tags-for-lead`,
    headers: {},
    queryParams: { leadId },
  };

  try {
    const response: AxiosResponse<ServerResponse<AssignedTagsToLeadDTO[], Error>> | undefined = await remoteCallObject.remoteGETCallV2<
      ServerResponse<AssignedTagsToLeadDTO[], Error>
    >(getCallInput);

    if (response?.data?.data) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error fetching assigned tags:', error);
    return null;
  }
};

const GetLeadsWithAssignedTagAPICall = async (tagId: string): Promise<AssignTagToLeadDTO[] | null> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/find-leads-with-assigned-tag`,
    headers: {},
    queryParams: { tagId },
  };

  try {
    const response: AxiosResponse<ServerResponse<AssignTagToLeadDTO[], Error>> | undefined = await remoteCallObject.remoteGETCallV2<
      ServerResponse<AssignTagToLeadDTO[], Error>
    >(getCallInput);

    if (response?.data?.data) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error fetching leads with assigned tag:', error);
    return null;
  }
};

const GetLeadsAssignedToTeamMemberAPICall = async (teamMemberEmail: string): Promise<string[] | null> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/leads-assigned-to-team-member`,
    headers: {},
    queryParams: { teamMemberEmail },
  };

  try {
    const response: AxiosResponse<ServerResponse<string[], Error>> | undefined = await remoteCallObject.remoteGETCallV2<
      ServerResponse<string[], Error>
    >(getCallInput);

    if (response?.data?.data) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error fetching leads assigned to team member:', error);
    return null;
  }
};






interface TagAssignmentResult {
    success: boolean;
    message?: string;
}

const AssignTagToLeadAPICall = async (tagId: string, leadId: string): Promise<TagAssignmentResult> => {
    const postCallInput: RemotePOSTCallInputObject<AssignTagToLeadDTO> = {
        apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/assign-tag-to-lead`,
        headers: {},
        object: {
            tagId,
            leadId
        }
    };

    try {
        const response: AxiosResponse<ServerResponse<any, any>> = await remoteCallObject.remotePOSTCallV2<
            ServerResponse<any, any>,
            AssignTagToLeadDTO
        >(postCallInput);

        if (response && response.data) {
            // Check if there's an error in the response
            if (response.data.errorDetails) {
                return {
                    success: false,
                    message: response.data.errorDetails.message || 'Failed to assign tag'
                };
            }

            // Check if the response indicates success
            if (response.data.data !== undefined) {
                return {
                    success: true,
                    message: 'Tag assigned successfully'
                };
            }
        }

        return {
            success: false,
            message: 'Unexpected response format'
        };
    } catch (error: any) {
        console.error('Error assigning tag to lead:', error);

        // Try to extract error message from axios error response
        if (error.response && error.response.data && error.response.data.errorDetails) {
            return {
                success: false,
                message: error.response.data.errorDetails.message || 'Failed to assign tag'
            };
        }

        return {
            success: false,
            message: 'Network error occurred while assigning tag'
        };
    }
};

interface TagUnassignmentResult {
    success: boolean;
    message?: string;
}

const UnassignTagFromLeadAPICall = async (tagId: string, leadId: string): Promise<TagUnassignmentResult> => {
    const postCallInput: RemotePOSTCallInputObject<AssignTagToLeadDTO> = {
        apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/unassign-tag-from-lead`,
        headers: {},
        object: {
            tagId,
            leadId
        }
    };

    try {
        const response: AxiosResponse<ServerResponse<any, any>> = await remoteCallObject.remotePOSTCallV2<
            ServerResponse<any, any>,
            AssignTagToLeadDTO
        >(postCallInput);

        if (response && response.data) {
            // Check if there's an error in the response
            if (response.data.errorDetails) {
                return {
                    success: false,
                    message: response.data.errorDetails.message || 'Failed to unassign tag'
                };
            }

            // Check if the response indicates success
            if (response.data.data !== undefined) {
                return {
                    success: true,
                    message: 'Tag unassigned successfully'
                };
            }
        }

        return {
            success: false,
            message: 'Unexpected response format'
        };
    } catch (error: any) {
        console.error('Error unassigning tag from lead:', error);

        // Try to extract error message from axios error response
        if (error.response && error.response.data && error.response.data.errorDetails) {
            return {
                success: false,
                message: error.response.data.errorDetails.message || 'Failed to unassign tag'
            };
        }

        return {
            success: false,
            message: 'Network error occurred while unassigning tag'
        };
    }
};

const BatchAssignTagToLeadsAPICall = async (tagId: string, leadIds: readonly string[]): Promise<BatchTagAssignmentResult> => {
    const postCallInput: RemotePOSTCallInputObject<AssignTagToLeadsDTO> = {
        apiUrl: `${backendApiBasePathLocal}v1/seller-client/sales/assign-tag-to-leads`,
        headers: {},
        object: {
            tagId,
            leadIds
        }
    };

    try {
        const response: AxiosResponse<ServerResponse<string[], any>> = await remoteCallObject.remotePOSTCallV2<
            ServerResponse<string[], any>,
            AssignTagToLeadsDTO
        >(postCallInput);

        if (response && response.data) {
            if (response.data.errorDetails) {
                return {
                    success: false,
                    successfulLeadIds: [],
                    message: response.data.errorDetails.message || 'Failed to assign tag to leads'
                };
            }

            if (response.data.data) {
                return {
                    success: true,
                    successfulLeadIds: response.data.data,
                    message: `Tag assigned to ${response.data.data.length} lead(s) successfully`
                };
            }
        }

        return {
            success: false,
            successfulLeadIds: [],
            message: 'Unexpected response format'
        };
    } catch (error: any) {
        console.error('Error batch assigning tag to leads:', error);

        if (error.response && error.response.data && error.response.data.errorDetails) {
            return {
                success: false,
                successfulLeadIds: [],
                message: error.response.data.errorDetails.message || 'Failed to assign tag to leads'
            };
        }

        return {
            success: false,
            successfulLeadIds: [],
            message: 'Network error occurred while assigning tag to leads'
        };
    }
};

const CreateWorkyLeadTagAPICall = async (tagName: string, tagDescription?: string): Promise<SellerClientTagDTO | null> => {
    try {
        const accessToken = getAccessToken();
        if (!accessToken) {
            console.error('No access token available for create tag request');
            return null;
        }

        const requestBody: WorkyLeadTagDTO = {
            tagName: tagName,
            tagDescription: tagDescription || undefined
        };

        const response = await axios.post(
            `${backendApiBasePathLocal}v1/seller-client/sales/create-worky-lead-tag`,
            requestBody,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        if (response && response.data && response.data.data) {
            return response.data.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error creating worky lead tag:', error);
        return null;
    }
};

const DeleteWorkyLeadTagAPICall = async (tagId: string): Promise<boolean> => {
    try {
        const accessToken = getAccessToken();
        if (!accessToken) {
            console.error('No access token available for delete tag request');
            return false;
        }

        const response = await axios.delete(
            `${backendApiBasePathLocal}v1/seller-client/sales/delete-worky-lead-tag`,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                },
                params: {
                    tagId: tagId
                }
            }
        );

        if (response && (response.status === 200 || response.status === 204)) {
            return true;
        }
        
        if (response && response.data && !response.data.errorDetails) {
            return true;
        }
        
        return false;
    } catch (error) {
        console.error('Error deleting worky lead tag:', error);
        return false;
    }
};

const UpdateWorkyLeadTagAPICall = async (tagDTO: TagDTO): Promise<SellerClientTagDTO | null> => {
    try {
        const accessToken = getAccessToken();
        if (!accessToken) {
            console.error('No access token available for update tag request');
            return null;
        }

        const response = await axios.put(
            `${backendApiBasePathLocal}v1/seller-client/sales/update-worky-lead-tag`,
            tagDTO,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        if (response && response.data && response.data.data) {
            return response.data.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error updating worky lead tag:', error);
        return null;
    }
};

const GetGroupedLeadStatusChangeEventsAPICall = async (
  startDateTimeEpochSeconds: number,
  endDateTimeEpochSeconds: number
): Promise<GroupedLeadStatusChangeEventsDTO | null> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/statistics/lead-status-changes-grouped`,
    headers: {},
    queryParams: {
      startDateTimeEpochSeconds: startDateTimeEpochSeconds.toString(),
      endDateTimeEpochSeconds: endDateTimeEpochSeconds.toString(),
    },
  };

  try {
    const response: AxiosResponse<ServerResponse<GroupedLeadStatusChangeEventsDTO, Error>> | undefined = 
      await remoteCallObject.remoteGETCallV2<ServerResponse<GroupedLeadStatusChangeEventsDTO, Error>>(getCallInput);

    if (response?.data?.data) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error fetching grouped lead status change events:', error);
    return null;
  }
};

const SendCalendarTaskAPICall = async (request: EmailCalendarTaskDTO): Promise<EmailCalendarTaskRespDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<EmailCalendarTaskDTO> = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/tasks/send-calendar-task`,
    headers: {},
    object: request,
  };

  try {
    const response: AxiosResponse<ServerResponse<EmailCalendarTaskRespDTO, Error>> = 
      await remoteCallObject.remotePOSTCallV2<ServerResponse<EmailCalendarTaskRespDTO, Error>, EmailCalendarTaskDTO>(postCallInput);

    if (response && response.data && response.data.data) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error sending calendar task:', error);
    return null;
  }
};

const ViewEventsAPICall = async (
  startDateTimeEpochSeconds: number,
  endDateTimeEpochSeconds: number,
  optionalUserEmail?: string
): Promise<ViewEventsRespDTO | null> => {
  const queryParams: Record<string, string> = {
    startDateTimeEpochSeconds: startDateTimeEpochSeconds.toString(),
    endDateTimeEpochSeconds: endDateTimeEpochSeconds.toString(),
  };

  if (optionalUserEmail) {
    queryParams.userEmail = optionalUserEmail;
  }

  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: `${backendApiBasePathLocal}v1/seller-client/tasks/view-events`,
    headers: {},
    queryParams: queryParams,
  };

  try {
    const response: AxiosResponse<ServerResponse<ViewEventsRespDTO, Error>> | undefined = 
      await remoteCallObject.remoteGETCallV2<ServerResponse<ViewEventsRespDTO, Error>>(getCallInput);

    if (response?.data?.data) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error fetching view events:', error);
    return null;
  }
};


export { 
  CreateAgencySalesLeadNoteAPICall, 
  GetAgencySalesLeadAPICall, 
  GetAgencySalesLeadDetailsAPICall, 
  GetAgencyTeamMembersAPICall,
  AssignLeadsToTeamMemberAPICall,
  UpdateSalesLeadStatusAPICall,  
  CreateNewLeadAPICall,
  UpdateSalesLeadNoteDTOAPICall,
  AddTargetBusinessLeadOrgEmployeeContactAPICall,
  CreateSalesLeadContactEmailFeedbackAPICall,
  CreateSalesLeadContactPhoneNumberFeedbackAPICall,
  UpdateContactDetailEmailsAPICall,
  UpdateContactDetailPhonesAPICall,
  GetCurrentLeadsV2APICall,
  SendSellerClientEmailAPICall,
  GetSellerClientTagsAPICall,
  GetAssignedTagsForLeadAPICall,
  GetLeadsWithAssignedTagAPICall,
  GetLeadsAssignedToTeamMemberAPICall,
  AssignTagToLeadAPICall,
  UnassignTagFromLeadAPICall,
  BatchAssignTagToLeadsAPICall,
  CreateWorkyLeadTagAPICall,
  DeleteWorkyLeadTagAPICall,
  UpdateWorkyLeadTagAPICall,
  GetGroupedLeadStatusChangeEventsAPICall,
  SendCalendarTaskAPICall,
  ViewEventsAPICall
};

